import { render, staticRenderFns } from "./orderProfit.vue?vue&type=template&id=5324f907"
import script from "./orderProfit.vue?vue&type=script&lang=js"
export * from "./orderProfit.vue?vue&type=script&lang=js"
import style0 from "./orderProfit.vue?vue&type=style&index=0&id=5324f907&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports